import { useState, useEffect } from "react"
import useIsMobile from "./useIsMobile"

export const useFormat = format => {
  const [style, setStyle] = useState({})
  const isMobile = useIsMobile()

  useEffect(() => {
    if (format.ratio /* && !isMobile */) {
      const width = format.ratio.width / format.ratio.height
      const height = format.ratio.height / format.ratio.width
      const size = format.size ? format.size/100 : 1
      format.boundaries === "full"
        ? setStyle({
            minWidth: isMobile ? `calc(100vw)` : `calc(100vh * ${width})`,
            minHeight: `calc(100vw * ${height})`,
            position: "absolute",
            padding: 0,
            left: "calc(50%)",
            top: "50%",
            transform: `translate(-50%, -50%) scale(${size})`,
          })
        : setStyle({
            height: `calc(${height * 100}vw - var(--spacing-xxl) * ${height} * 2)`,
            transform: `translate(0%, -50%) scale(${size})`,
            position: 'absolute',
            top: '50%',
            padding: '0 var(--spacing-xxl)',
            overflow: "visible",
          })
    }
  }, [format])

  return style
}